import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { env } from '~/commons/config';

import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import useHttpStatus from '~/commons/hooks/useHttpStatus';

import ArticlePreview from './ArticlePreview.jsx';

const PageArticlePreview = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    req({
      url: `api/quiz/articles/${_id}`,
    });
  }, []);

  return (
    <PageHttp res={res}>
      {(doc) => (
        <ArticlePreview article={doc}>
          <Header
            breadcrumb={[
              { to: '../../', children: 'Articles' },
              { to: '../', children: doc.title },
            ]}
          >Preview</Header>
        </ArticlePreview>
      )}
    </PageHttp>
  );
};

export default PageArticlePreview;
